// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"

import { onGet } from "./fakeDB"

export const getData = createAsyncThunk(
  "datatables/getData",
  async (params) => {
    const response = onGet(params)
    return {
      allData: response[1].allData,
      data: response[1].invoices,
      totalPages: response[1].total,
      params
    }
  }
)

export const datatablesSlice = createSlice({
  name: "datatables",
  initialState: {
    data: [],
    buyerModal: {
      open: false,
      data: {}
    },
    sellerModal: {
      open: false,
      data: {}
    },
    insuranceInfoModal: {
      open: false,
      data: {}
    },
    total: 1,
    params: {},
    allData: []
  },
  reducers: {
    toggleBuyerModal: (state, action) => {
      state.buyerModal.open = !state.buyerModal.open
      state.buyerModal.data = action.payload
    },
    toggleSellerModal: (state, action) => {
      state.sellerModal.open = !state.sellerModal.open
      state.sellerModal.data = action.payload
    },
    toggleInsuranceInfoModal: (state, action) => {
      state.insuranceInfoModal.open = !state.insuranceInfoModal.open
      state.insuranceInfoModal.data = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.params = action.payload.params
      state.allData = action.payload.allData
      state.total = action.payload.totalPages
    })
  }
})

export const { toggleBuyerModal, toggleSellerModal, toggleInsuranceInfoModal } = datatablesSlice.actions
export default datatablesSlice.reducer
